import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import ayudaa from "../assets/web/ayudaa.png";
import minibar from "../assets/web/minibar.png";
import HireUsModal from "../components/HireUsModal";
function AppListComponent() {
  const [sites] = useState([
    {
      image: ayudaa,
      companyName: "Ayudaa",
      techStack: "React Native",
      type: "App",
      url: "https://play.google.com/store/apps/details?id=com.ayudaa",
    },
    {
      image: minibar,
      companyName: "Minibar",
      techStack: "React Native",
      type: "App",
      url: "https://play.google.com/store/apps/details?id=in.minibar",
    },
  ]);
  return (
    <div className="site-list">
      <Container>
        {sites.map((data) => (
          <Row className="site" key={data.image}>
            <Col xs={12} md={6}>
              <img
                src={data.image}
                alt="..."
                className="img-fluid site-img shadow-sm"
              />
            </Col>
            <Col xs={12} md={6}>
              <div className="site-details shadow">
                <h3>{data.companyName}</h3>
                <div>
                  <p>
                    Building website is easy. But building website with good
                    performance is tricky. Here, we've some example to showcase.
                  </p>
                  <p>Framework / Language : {data.techStack}</p>
                  <p>Website Type : {data.type}</p>
                </div>
                <div>
                  <button className="btn btn-custom">
                    <a href={data.url} target="_blank">
                      View Demo
                    </a>
                  </button>
                  <HireUsModal outlined={true} />
                </div>
              </div>
            </Col>
          </Row>
        ))}
      </Container>
    </div>
  );
}

export default AppListComponent;
